const exceptionEventTypes = Object.freeze({
    outOfShift: 1,
    unplannedDowntime: 2,
    plannedDowntime: 3,
    overtime: 4,
    onShift: 5
});

export default exceptionEventTypes;
